import { useGetInventoryVirtualMachine } from "@/api/useInventory"
import { useQueryString } from "@/hooks/useQueryString"
import { getVirtualMachineTabData } from "./useVirtualMachine.selector"

export const useVirtualMachineInventory = (
  paramKeys?: { key: string }[],
  config?: { enabled: boolean; headers?: Record<string, string> }
) => {
  const params = useQueryString([
    "daysAgo",
    "orderBy",
    "ascending",
    ...(paramKeys || [])
  ])
  const context = useGetInventoryVirtualMachine(params, {
    select: getVirtualMachineTabData,
    ...(config || {})
  })
  return context
}
